"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("swiper/css");
require("swiper/css/effect-fade");
require("swiper/css/autoplay");
var swiper_1 = require("swiper");
var micromodal_1 = require("micromodal");
(function () {
    new swiper_1.default(".vision-swiper", {
        modules: [swiper_1.Autoplay, swiper_1.EffectFade],
        effect: "fade",
        fadeEffect: { crossFade: true },
        allowTouchMove: false,
        speed: 2000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });
    new swiper_1.default(".systems-swiper", {
        modules: [swiper_1.FreeMode, swiper_1.Autoplay],
        allowTouchMove: false,
        width: 600,
        loop: true,
        freeMode: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        speed: 20000,
        loopAdditionalSlides: 3,
    });
})();
(function () {
    micromodal_1.default.init({ awaitCloseAnimation: true, disableScroll: true });
})();
(function () {
    var button = document.querySelector("#memberInterviewsMoreButton");
    var interviews = document.querySelector("#memberInterviews");
    button.addEventListener("click", function () {
        button.parentElement.classList.add("hidden");
        interviews.classList.add("all");
    });
})();
